import React from "react";
import { connect } from "react-redux";
import { useRouteMatch, withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

import Card from "../Card/Card.js";
import CardBody from "../Card/CardBody";
import Button from "../LogButton/Button";

import { cardTitle } from "../../Assets/jss/material-kit-react.js";
// import { customAlert } from "../Alert/alert.component";
import "./customCard.styles.scss";

const CustomCard = ({ subject, history, currentUser }) => {
  const { url } = useRouteMatch();
  const { name, marks } = subject;
  const classes = useStyles();
  return (
    <div className="card-component">
      <Card
        style={{
          width: "100%",
          height: "auto",
          overflow: "auto",
          fontFamily: "Montserrat",
          backgroundColor: "#233975",
          textAlign: "center",
          flexDirection: "row",
        }}
      >
        <CardBody>
          <h4 className={classes.cardTitle}>
            <FontAwesomeIcon
              icon={faGraduationCap}
              style={{ marginRight: "10px" }}
            />
            {name}
          </h4>
          <p className={classes.subText}>Marks: {marks}</p>
          <Button
            onClick={() =>
              history.push(`${url}/Exam/Subject?=${name}User?=${currentUser}`)
            }
            style={{ marginTop: "7vh" }}
          >
            proceed
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

const styles = {
  cardTitle,
  textCenter: {
    textAlign: "center",
    backgroundColor: "#233975",
  },
  subText: {
    fontSize: "calc(10px + 0.2vw)",
    color: "white",
  },
};

const mapStateToProps = ({ user: { currentUser } }) => ({
  currentUser,
});

const useStyles = makeStyles(styles);

export default withRouter(connect(mapStateToProps, null)(CustomCard));
